<template>
  <section class="partners-section">
    <article class="container">
      <header>
        <h2>С нами работают</h2>
      </header>

      <div class="partner-logo-carousel">
        <div class="track">
          <div
            v-for="partner in partners"
            :key="partner.id"
            :ref="'partner-logo-' + partner.id"
          >
            <img :src="partner.src">
          </div>
        </div>
      </div>
    </article>
  </section>
</template>

<script>
export default {
	name: 'SectionPartners',
	data() {
		// Импортируем все изображения партнеров
		const modules = import.meta.glob('@/assets/images/partners/*.webp', { eager: true });

		const partners = Object.entries(modules).map(([path, module], index) => {
			const filename = path.split('/').pop();
			const id = parseInt(filename.replace('.webp', ''));
			return {
				id: id,
				src: module.default,
			};
		}).sort((a, b) => a.id - b.id); // Сортируем по id

		return {
			partners,
		};
	},
};
</script>

<style lang="scss" src="./SectionPartners.scss" />
